module.exports = __webpack_public_path__ + "static/media/sub-footer-bg.aa0bf5a6.jpg";